export const dashboard = {
  title: "لوحة التحكم",
  filters: {
    accommodation: "وحدة الإقامة",
    allAccommodations: "جميع وحدات الإقامة",
    period: "الفترة",
    periodOptions: {
      today: "اليوم",
      week: "الأسبوع",
      month: "الشهر",
      year: "السنة",
    },
  },
  actions: {
    createBooking: "إنشاء حجز",
  },
  pendingWidget: {
    title: "الإجراءات المعلّقة",
    subtitle: "المدفوعات والطلبات والغرف التي يجب تعيينها.",
    oneRequest: "طلب",
    manyRequests: "طلبات",
    onePayment: "دفعة",
    manyPayments: "دفعات",
    oneUnassigned: "للتعيين",
    manyUnassigned: "للتعيين",
    loading: "جارٍ تحميل الإجراءات المعلّقة...",
    emptyTitle: "لا توجد إجراءات معلّقة",
    emptyText: "عند ورود طلب جديد أو وجود حجز بانتظار الدفع، سيظهر هنا.",
    noName: "بدون اسم",
    accommodation: "وحدة الإقامة",
    guest: "ضيف",
    guests: "ضيوف",
    requestShort: "طلب",
    pendingPaymentShort: "بانتظار الدفع",
    unassignedShort: "تعيين غرفة",
    approve: "قبول",
    reject: "رفض",
    viewAll: "عرض جميع الحجوزات",
    modalApproveTitle: "قبول الطلب",
    modalRejectTitle: "رفض الطلب",
    modalApproveText1: "أنت على وشك قبول الطلب المُقدَّم من",
    modalApproveText2: "إذا كان هذا الحجز يستخدم الدفع الإلكتروني، فسينتقل إلى حالة انتظار الدفع.",
    modalRejectText1: "أنت على وشك رفض الطلب المُقدَّم من",
    modalRejectText2: "يمكنك تقديم سبب لإرساله إلى الضيف عبر البريد الإلكتروني.",
    rejectReasonLabel: "سبب الرفض",
    rejectReasonPlaceholder: "اختر سببًا",
    reasonDatesUnavailable: "التواريخ لم تعد متاحة",
    reasonPriceUnavailable: "السعر لم يعد متاحًا",
    reasonMinimumStay: "لا يستوفي الحد الأدنى لمدة الإقامة",
    reasonHouseRules: "لا يستوفي قواعد مكان الإقامة",
    reasonOther: "سبب آخر",
    rejectReasonOtherPlaceholder: "اكتب سبب الرفض",
    rejectReasonRequired: "يجب اختيار سبب الرفض.",
    rejectReasonOtherRequired: "يجب كتابة سبب الرفض.",
    cancel: "إلغاء",
    confirmApprove: "نعم، اقبل",
    confirmReject: "نعم، ارفض",
    statusUpdatedSuccess: "تم تحديث الحالة بنجاح.",
    statusUpdatedError: "تعذّر تحديث الحالة."
  },

  stats: {
    totalReservations: {
      today:   "حجوزات اليوم",
      week:    "حجوزات هذا الأسبوع",
      month:   "حجوزات هذا الشهر",
      year:    "حجوزات هذه السنة",
      default: "إجمالي الحجوزات",
    },
    checkIns: {
      today:   "عمليات تسجيل الوصول اليوم",
      week:    "عمليات تسجيل الوصول هذا الأسبوع",
      month:   "عمليات تسجيل الوصول هذا الشهر",
      year:    "عمليات تسجيل الوصول هذه السنة",
      default: "عمليات تسجيل الوصول",
    },
    occupancy: {
      today:   "الإشغال اليوم",
      week:    "الإشغال الأسبوعي",
      month:   "الإشغال الشهري",
      year:    "الإشغال السنوي",
      default: "الإشغال",
    },
    revenue: {
      today:   "إيرادات اليوم",
      week:    "الإيرادات الأسبوعية",
      month:   "الإيرادات الشهرية",
      year:    "الإيرادات السنوية",
      default: "الإيرادات",
    },
  },
  section3: {
    title: "الحجوزات القادمة",
    subtitle: "قائمة عمليات الوصول القادمة لمكان إقامتك",
    timeFilters: {
      upcoming: "القادمة",
      thisWeek: "هذا الأسبوع",
      today: "اليوم",
      tomorrow: "غدًا",
      month: "الشهر",
    },
    table: {
      headers: {
        responsible: "المسؤول",
        checkInDate: "تاريخ تسجيل الوصول",
        entry: "الدخول",
        guests: "الضيوف",
        status: "الحالة",
      },
    },
    empty: {
      today: {
        title: "لا توجد لديك عمليات وصول لهذا اليوم",
        description:
          "عند وجود عملية وصول جديدة مجدولة لهذا اليوم، ستظهر هنا مع تفاصيلها المهمة.",
      },
      default: {
        title: "لا توجد لديك عمليات وصول قادمة",
        description:
          "عند وجود عمليات وصول مجدولة جديدة، ستظهر هنا مع تفاصيلها المهمة.",
      },
    },
    loading: "جارٍ تحميل الحجوزات...",
    statuses: {
      inProgress: "قيد التنفيذ",
      complete: "مكتمل",
      pending: "معلّق",
      approved: "مقبول",
    },
    actions: {
      replyOnWhatsApp: "الرد عبر WhatsApp",
    },
    nights: "{count} ليلة | {count} ليالٍ",
  },
  section4: {
    title: "تفصيل الإيرادات",
    total: "إجمالي الإيرادات",
    emptyChart: "لا توجد بيانات متاحة",
    noData: "لا توجد بيانات إيرادات لعرضها",
  },
  section5: {
    title: "إجمالي الإيرادات",
    datasetLabel: "الإيرادات",
    filters: {
      weekly: "أسبوعي",
      monthly: "شهري",
      "6m": "6 أشهر",
      "12m": "12 شهرًا",
      "24m": "24 شهرًا",
    },
    loading: "جارٍ تحميل البيانات...",
    errors: {
      load: "خطأ في تحميل البيانات",
      connection: "خطأ في الاتصال",
    },
  },
  design: {
    title: `تصميم اللوحة`,
    reorder: `إعادة الترتيب`,
    active: `نشط`,
    theme: `السمة`,
    color: `ملوّن`,
    green: `أخضر`,
    system: `النظام`,
    white: `أبيض`,
    sidebar: `الشريط الجانبي`,
    black: `أسود`,
  },
  earlyCheckin: {
    earlyShort: `مبكرًا`,
    arrivesShort: `وصول`,
    arrivalAt: `الساعة {time}`,
    requested: `طلب تسجيل وصول مبكر`,
    arrivalRequested: `طلب وقت الوصول`,
  },
};
